import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import sendEmailConfig from "servicestack/email/send-email-config";
import cartConfig from "emun.cart/cart.config";
import labels from "emun.order/_labels";
import required from "emun.order/_required";

export default class PartsOrderHeaderFeildsetController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = cartConfig;
    $ctrl.today = new Date().getTime();
    $ctrl.labels = labels;
    $ctrl.required = required;
    $ctrl.recipients = sendEmailConfig.recipients;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.locations = new AutoQuery({
      url: "QueryRetailerShippingLocations.json?Status=Active",
      critiera: {
        StatusNotEqualTo: "Inactive"
      },
      orderBy: "Name",
      autoLoad: false,
      onLoaded: args => $ctrl.locationsLoaded(args)
    });
    $ctrl.contacts = new AutoQuery({
      url: "QueryRetailerContacts.json",
      orderBy: "Name",
      autoLoad: false,
      onLoaded: args => $ctrl.contactsLoaded(args)
    });

    const retailerId = $ctrl.order.retailerId || $ctrl.$session.retailerId;
    if (retailerId) {
      $ctrl.locations.bus
        .send("QueryRetailers.json?Id=" + retailerId)
        .then(({ data }) => $ctrl.selectRetailer(data.results[0]));
    }
  }

  toggleRecipient(recipient, fieldName = "recipients") {
    sendEmailConfig.toggleRecipient(recipient, this.order, fieldName);
  }

  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    return $ctrl.locations.bus.send(url).then(res => res.data.results);
  }

  selectRetailer(val) {
    const $ctrl = this;
    console.debug("selectRetailer: ", val);
    $ctrl.order.companyName = val.companyName;
    $ctrl.order.retailerId = val.id;
    $ctrl.order.retailer = val;

    $ctrl.locations.filter("RetailerId", $ctrl.order.retailerId);
    $ctrl.contacts.filter("RetailerId", $ctrl.order.retailerId);
  }

  locationsLoaded(args) {
    let $ctrl = this;
    console.info("locationsLoaded", $ctrl.order, args);
    console.info("$ctrl.order.shipId", $ctrl.order.shipId);
    const matches = args.results.filter(sl => sl.id === $ctrl.order.shipId);
    $ctrl.order.dropShip = false;
    if (matches.length > 0) {
      $ctrl.order.shippingLocation = matches[0];
    } else if (args.results.length === 1) {
      $ctrl.order.shippingLocation = args.first;
      $ctrl.order.shipId = (args.first || {}).id;
    }
    console.info("location loaded", $ctrl.order.shippingLocation);
  }
  changeShippingLocation() {
    let $ctrl = this;
    console.info("$ctrl.order.shipId", $ctrl.order.shipId);
    if ($ctrl.order.shipId === "DROPSHIP") {
      $ctrl.order.dropShip = true;
      $ctrl.order.shippingLocation = {
        id: "DROPSHIP",
        dropShip: true,
        country: "US"
      };
    } else {
      $ctrl.order.dropShip = false;
      const location = $ctrl.locations.results.filter(
        r => r.id === $ctrl.order.shipId
      )[0];
      $ctrl.order.shippingLocation = location;
      $ctrl.order.shipId = location.id;
      console.info("select location", location);
    }
    console.info("location loaded", $ctrl.order.shippingLocation);
  }

  contactsLoaded(args) {
    let $ctrl = this;
    const contact = args.results
      .filter(c => c.isPrimary)
      .concat(args.results)[0];
    if (contact) {
      $ctrl.contact = contact;
      $ctrl.order.contactName = contact.name;
    }
  }
}
